import { Box, Grid, styled } from '@mui/material';
import Theme from 'App.theme';
import { TableContainer } from 'components/Table/Table';

export const SearchFiltersBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.layout.spacing.small,
  paddingBottom: theme.layout.spacing.small,
}));

export const SearchInputGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  rowGap: theme.layout.spacing.small,
}));

export const DropTableContainer = styled(TableContainer)`
  max-height: 100%;
  border: 0;

  .thick-column-divider .MuiDataGrid-columnHeader,
  .thick-column-divider .MuiDataGrid-cell {
    border-right: 2px solid ${Theme.greys.GREY0};
  }

  .MuiDataGrid-columnHeaders {
    border-bottom: 2px solid ${Theme.greys.GREY0};
  }

  .MuiDataGrid-cell {
    border-bottom: 3px solid ${Theme.greys.GREY0};
  }

  /* Adjust hover effect for red-highlighted rows */
  .red-highlight:hover {
    background-color: ${Theme.colours.hoverRed} !important;
  }

  .red-highlight {
    background-color: ${Theme.colours.redOpaque};
  }
`;

export const ModalContent = styled('div')`
  background-color: ${Theme.colours.white};
  padding: 24px 40px;
`;
